import { FetchEndpoint } from 'utils/endpoint/FetchEndpoint';
import { postJson } from 'utils/http/postJson';

import type { CmsApiMovementSignupCount } from './types/CmsApiMovementSignupCount';

type ApiResponse = CmsApiMovementSignupCount;

function mapResponse(response: ApiResponse): CmsApiMovementSignupCount {
  return response;
}

const fetchEndpoint = new FetchEndpoint({
  urlFactory: (movementSlug: string) =>
    `/data/website/movements/${movementSlug}`,
  mapResponse,
});

// Exports

export const useCmsApiGetMovementSignupCount =
  fetchEndpoint.createUseFetchHook();

export async function cmsApiSignUpForMovement(
  movementSlug: string,
  blockId: string,
  sectionIndex: number,
): Promise<CmsApiMovementSignupCount> {
  return postJson<CmsApiMovementSignupCount>(
    `/data/website/movements/${movementSlug}`,
    { blockId, sectionIndex },
  );
}
